import type { UploadFile } from '../../../lib/upload';

/** Web: hidden <input type="file"> limited to spreadsheets. */
export function pickSpreadsheet(): Promise<UploadFile | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel';
    input.style.display = 'none';
    let done = false;
    const finish = (f: UploadFile | null) => {
      if (done) return;
      done = true;
      input.remove();
      resolve(f);
    };
    input.addEventListener('change', () => {
      const file = input.files?.[0];
      finish(file ? { uri: URL.createObjectURL(file), name: file.name, type: file.type || 'text/csv', size: file.size, file } : null);
    });
    input.addEventListener('cancel', () => finish(null));
    document.body.appendChild(input);
    input.click();
  });
}

export const SPREADSHEET_SUPPORTED = true;
